module.exports = __webpack_public_path__ + "static/media/31.a534e591.png";